export default {"src":"/_next/static/media/kitchen.4a145b0c.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};